import { render } from "./icons-close.svg?vue&type=template&id=9c2a7e10?inline"
const script = {}
script.render = render

export default script